// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseVideo_wrapper_V3mxl","imageWrapper":"BaseVideo_imageWrapper_1ylj1","buttonWrapper":"BaseVideo_buttonWrapper_3-q51"};